import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SettingsService } from '@app/settings.service';
import { ButtonComponent } from '@app/shared/button/button.component';
import { NgxMaskModule } from 'ngx-mask';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, ButtonComponent, NgxMaskModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  footerIcons: { icon: string; link: string }[] = [
    { icon: 'assets/images/new-design-icons/Facebook (white).svg', link: 'https://www.facebook.com/vitrina.nedvizhimosti' },
    { icon: 'assets/images/new-design-icons/Instagram (white).svg', link: 'https://www.instagram.com/ivitrina.kz/?igshid=YmMyMTA2M2Y=' },
    { icon: 'assets/images/new-design-icons/Spotify (white).svg', link: 'https://www.tiktok.com/@ivitrina.kz' },
    { icon: 'assets/images/new-design-icons/Youtube (white).svg', link: 'https://www.youtube.com/channel/UCTM82jnI4dx5o4HVMH-qMOw' },
  ];

  constructor(private _settingsService: SettingsService) {}

  openSendBid() {
    this._settingsService.openApplyApplicationModal();
  }

  redirectToLink(link: string) {
    document.location.href = link;
  }
}
